import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initstate";
 
export const portSlice = createSlice({
    name: "portInfo",
    initialState,
    reducers: {
      addPort: (state, action) => {
        state.portList.push(action.payload);  
      },
      updatePort: (state, action) => {
        const updatedPort = action.payload;
        const index = state.portList.findIndex((port) => port.id === updatedPort.id);
        if (index !== -1) {
          state.portList[index] = updatedPort; 
        }
      },
      deletePort: (state, action) => {
        const deleteId = action.payload;
         state.portList = state.portList.filter((port) => port.id !== deleteId); 
      },
    },
  });
  

export const { addPort, updatePort, deletePort } = portSlice.actions;

export default portSlice.reducer;
